export default {
  fromValue (val) {
    switch (val) {
      case 'company':
        return 'Pessoa Jurídica'
      case 'person':
        return 'Pessoa Física'
      default:
        return val
    }
  }
}
